module.exports = __webpack_public_path__ + "static/media/microsoft-logo.a5ea26f8.svg";